<template>
  <div v-if="profile">
    <!-- button for editing profile -->
    <v-row>
      <v-spacer />
      <IconButton
        class="ma-0"
        :label="$t('Edit')"
        icon="mdi-pencil"
        @click="openCreateEditDialog(profile)"
      />
    </v-row>

    <!-- Avatar/Name -->
    <v-list-item class="align-center">
      <template #prepend>
        <div style="position: relative">
          <!-- edit/delete avatar image -->
          <div style="position: absolute; top: 0; left: -18px;">
            <div style="margin-bottom: 45px;">
              <UploadAvatar
                :user-id="profile.id"
                @uploaded="reload()"
              />
            </div>
            <div>
              <DeleteAvatar
                v-if="profile.avatar_cache"
                :user-id="profile.id"
                @deleted="reload()"
              />
            </div>
          </div>
          <!-- Avatar Image -->
          <OpAvatar
            :size="100"
            :profile="profile"
          />
        </div>
      </template>
      <v-list-item-title class="ml-3 text-h5">
        {{ getFullName() }}
      </v-list-item-title>
      <v-list-item-subtitle class="ml-3">
        {{ profile.first_name_en }}&nbsp;{{ profile.last_name_en }}
      </v-list-item-subtitle>
    </v-list-item>

    <!-- profile info -->
    <v-list class="ml-5">
      <!-- Email -->
      <v-list-item
        class="mb-3"
        prepend-icon="mdi-email"
      >
        <v-list-item-subtitle>{{ $t('User.EmailAddress') }}</v-list-item-subtitle>
        <v-list-item-title>{{ profile.email }}</v-list-item-title>
      </v-list-item>

      <!-- 言語 -->
      <v-list-item
        class="mb-3"
        prepend-icon="mdi-web"
      >
        <v-list-item-subtitle>{{ $t('User.Language') }}</v-list-item-subtitle>
        <v-list-item-title>{{ profile.language_name }}</v-list-item-title>
      </v-list-item>

      <!-- タイムゾーン -->
      <v-list-item
        class="mb-3"
        prepend-icon="mdi-clock-outline"
      >
        <v-list-item-subtitle>{{ $t('User.Timezone') }}</v-list-item-subtitle>
        <v-list-item-title>{{ profile.timezone }}</v-list-item-title>
      </v-list-item>

      <!-- Roles -->
      <v-list-item
        class="mb-3"
        prepend-icon="mdi-shield-check"
      >
        <v-list-item-subtitle>{{ $t('User.Role.Roles') }}</v-list-item-subtitle>
        <v-list-item-title
          v-if="profile.roles.length > 0"
          class="align-center flex-wrap"
        >
          <v-chip
            v-for="(v, i) in profile.roles"
            :key="i"
            color="primary"
            variant="flat"
            density="compact"
          >
            {{ $t('User.Role.' + v) }}
          </v-chip>
        </v-list-item-title>
        <div v-else>
          {{ $t('None') }}
        </div>
      </v-list-item>

      <!-- UserGroups -->
      <v-list-item
        class="mb-3"
        prepend-icon="mdi-account-multiple"
      >
        <v-list-item-subtitle>{{ $t('UserGroup.UserGroups') }}</v-list-item-subtitle>
        <v-layout
          v-if="profile.user_group_names.length > 0"
          class="flex-wrap align-center"
        >
          <v-chip
            v-for="(v, i) in profile.user_group_names"
            :key="i"
            density="compact"
          >
            {{ v }}
          </v-chip>
        </v-layout>
        <div v-else>
          {{ $t('None') }}
        </div>
      </v-list-item>
    </v-list>

    <!-- 無効ステータス表示 -->
    <v-alert
      v-if="!profile.is_active"
      type="error"
      :value="true"
    >
      {{ $t('User.DisableInfo') }}
    </v-alert>

    <!-- 新規/編集ダイアログ -->
    <CreateEditUserDialog
      v-model="createEditDialog"
      :current-data="editCurrentData"
      @reload="reload()"
    />
  </div>
  <div v-else>
    ...
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import CreateEditUserDialog from '@/components/dialogs/CreateEditUserDialog'
  import IconButton from '@/components/parts/button/IconButton'
  import _ from 'lodash'
  import OpAvatar from '@/components/parts/OpAvatar'
  import UploadAvatar from '@/components/dialogs/UploadAvatar'
  import DeleteAvatar from '@/components/dialogs/DeleteAvatar'

  export default {
    components: { DeleteAvatar, UploadAvatar, OpAvatar, IconButton, CreateEditUserDialog },
    props: {
      profile: {
        type: Object,
        default: null
      }
    },
    emits: ['reload'],
    data: () => ({
      createEditDialog: false,
      editCurrentData: null
    }),
    computed: {
      ...mapGetters(['login']),
      reverse () {
        return this.$i18n.locale !== 'ja'
      }
    },
    methods: {
      reload () {
        this.$emit('reload')
      },
      openCreateEditDialog (currentData) {
        this.editCurrentData = null
        if (currentData) {
          this.editCurrentData = _.cloneDeep(currentData)
        }
        this.createEditDialog = true
      },
      getFullName() {
        if (this.reverse) {
          return this.profile.first_name + ' ' + this.profile.last_name
        } else {
          return this.profile.last_name + ' ' + this.profile.first_name
        }
      }
    }
  }
</script>
